import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { thumbVerticalStyle, thumbStyleTrack } from "../../Styles/DynamicScrollbar/DynamicScrollbarStyle"

function DynamicScrollbar(props) {

  const renderThumbVertical = (propsF, style) => {
    const thumbStyleWithColor  = { ...style, ...thumbVerticalStyle };
    return <div {...propsF} style={thumbStyleWithColor} />;
  };

  const renderTrackVertical = (propsF, style) => {
    const thumbStyleWidth = { ...style, ...thumbStyleTrack };
    return <div {...propsF} style={thumbStyleWidth} />;
  }

  return (
    <Scrollbars 
      universal
      autoHeight 
      autoHeightMax={615} 
      renderThumbVertical={renderThumbVertical}
      renderTrackVertical={renderTrackVertical}
    >
      {props.children}
    </Scrollbars>
  );
}

export default DynamicScrollbar;